<script lang="ts">
	import { type Tippy } from 'svelte-tippy'

	// either specify width and height or size
	let {
		id = '',
		size = 16,
		height,
		width,
		src,
		alt = '',
		clickable = false,
		allowTransition = true,
		titleAttr = '',
		tippy = () => {}
	}: {
		id?: string
		size?: number
		height?: number
		width?: number
		src: string
		alt?: string
		clickable?: boolean
		allowTransition?: boolean
		titleAttr?: string
		tippy?: Tippy | (() => void)
	} = $props()

	let icon: HTMLImageElement | undefined = $state(undefined)
	let loaded = $state(false)

	const resolvedHeight = $derived(size && !height ? size : height)
	const resolvedWidth = $derived(size && !width ? size : width)

	$effect(() => {
		if (src) {
			loaded = false
			if (icon) {
				icon.onload = () => {
					loaded = true
				}
				icon.src = src
			}
		}
	})
</script>

<img
	bind:this={icon}
	class:loaded
	class:allowTransition
	{id}
	{alt}
	style:width={resolvedWidth + 'px'}
	style:height={resolvedHeight + 'px'}
	title={titleAttr}
	on:click
	style="cursor: {clickable ? 'pointer' : 'auto'}"
	use:tippy
/>

<style lang="scss">
	img.allowTransition {
		opacity: 0;
		transition: opacity 500ms ease-out;

		&.loaded {
			opacity: 1;
		}
	}
</style>
